<!--二级机构信息（备案记录）-->
<template>
  <div class="contentBox">
    <!-- 表格数据 -->
    <div class="tableBox">
      <!-- 入驻申请-->
      <div class="innovationVoucher">
        <img src="@/assets/images/table-tab.png" width="8px" height="23px" />
        <span>备案记录</span>
      </div>
      <!-- Tabs标签组件 -->
      <Tabs :tabs="tabsList">
        <template v-slot:button>
        </template>
        <template v-if="currentUsersData.length">
          <JRtable :table-data="currentUsersData" :selection="false" :show-pagination="true"
            :column="currentUsersColumns" :index="true" size="mini" :border="true" :pageOptions="pageOptions"
            @page-change="handlePageChange">
            <template slot="slot_record_bazt" slot-scope="data">
              <span v-if="data.scope.row.jgshzt=='009'">备案已完成</span>
              <span v-else>{{data.scope.row.jgshztName}}</span>
            </template>
            <template slot="slot_record_tools" slot-scope="data">
              <el-button size="mini" type="primary" icon="el-icon-view"
                @click="handleViewRedemptionDetails(data.scope.row)">查看</el-button>
            </template>
          </JRtable>
        </template>
        <template v-else>
          <div style="color: #333333; font-weight: 400; width: 64px; height: 30px; margin: 30px">暂无数据</div>
        </template>
      </Tabs>
      <!-- 入驻申请申请弹窗表单 -->
      <Dialog :visible.sync="showDialog" width="1500px" :title="title" :showBtn="false" @close="showDialog = false"
        :append-to-body="true">
        <template #content>
          <div class="applyform">
            <!-- 修改表单组件 -->
            <component :is="test" v-if="showDialog" :uuid="uuid" @closeDialog="closeDialog" @getJgrzList="getJgrzList"
              ref="childRef" :operation="operation"></component>
          </div>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import JRtable from '@/components/Table'
import Tabs from '@/components/Tabs'
import Dialog from '@/views/enterprise/components/Dialog'
import { getJgrzList } from '@/api/mechanism/enterApply'
// import enterApplyForm from '@/views/applyForm/enterApplyForm'
import JgApplyFormSecond from '@/views/applyForm/JgApplyFormSecond'
import { getUuid } from '@/utils'
export default {
  components: {
    JRtable,
    Tabs,
    Dialog,
    JgApplyFormSecond
  },
  computed: {
    currentUsersColumns() {
      // return this.$store.state.user.userType == '1' ? this.arr2 : this.arr1
      return this.arr1
    },
  },
  data() {
    return {
      test: 'JgApplyFormSecond',
      // 分页数据
      pageOptions: {
        page: 1,
        limit: 10,
        total: 0,
        // 统一社会信用代码
        tyshxydm: '',
        // 机构名称
        jgmc: '',
        // 审核状态
        spzt: ''
      },
      // 表格数据
      currentUsersData: [],
      // 顶部横向tabs切换栏目
      tabsList: [
        // {
        //   id: 0,
        //   value: '机构信息',
        //   isActive: true,
        //   quantity: ''
        // }
      ],
      // 是否显示dialog
      showDialog: false,
      // 当前uuid
      uuid: '',
      operation: false,
      // 机构入驻备案表单默认标题
      title: '机构入驻备案表单',
      arr1: [
        {
          label: '机构名称',
          prop: 'jgmc',
          align: 'center',
          // width: '200',
          truncate: true
        },
        // {
        //   label: '企业法人',
        //   prop: 'qyfr',
        //   align: 'center',
        //   // width: '200',
        //   truncate: true
        // },
        {
          label: '机构联系人',
          prop: 'jglxr',
          align: 'center',
          // width: '200',
          truncate: true
        },
        {
          label: '机构联系人电话',
          prop: 'jglxrdh',
          align: 'center',
          // width: 200,
          truncate: true
        },
        {
          label: '所属机构',
          prop: 'jgytdw',
          align: 'center',
          // width: 200,
          truncate: true
        },
        {
          label: '备案状态',
          prop: '',
          align: 'center',
          slot: 'slot_record_bazt',
          // width: '200',
          truncate: true
        },
        {
          label: '保存时间',
          prop: 'spsj',
          align: 'center',
          // width: '200',
          truncate: true
        },
        {
          label: '操作',
          prop: '',
          align: 'center',
          slot: 'slot_record_tools',
          // width: '200',
          // fixed: 'right'
        }
      ],
    }
  },
  created() {
    // 获取入驻过程表格数据
    this.getJgrzList()
  },
  methods: {
    // 获取入驻申请表格数据
    async getJgrzList() {
      let params = {
        page: this.pageOptions.page,
        size: this.pageOptions.limit,
        // ...this.searchForm
      }
      let res = await getJgrzList(params)
      if (res.code === 200) {
        this.currentUsersData = res.data.records
        this.pageOptions.total = res.data.total
        // this.tabsList[0].quantity = res.data.total
      } else {
        this.currentUsersData = []
        this.pageOptions.total = ''
        // this.tabsList[0].quantity = ''
      }
    },
    // 分页控制
    handlePageChange(val) {
      this.pageOptions.page = val.page
      this.pageOptions.limit = val.limit
      // 再获取表格数据
      this.getJgrzList()
    },
    // 点击查看详情
    handleViewRedemptionDetails(item) {
      this.operation = true
      this.showDialog = true
      this.$nextTick(() => {
        this.uuid = item.jgid // 记录uuid
        this.$refs.childRef.getDqJgDetail(item)
      })
    },
    closeDialog() {
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/form.scss';

.contentBox {
  width: 100%;
  height: 100%;

  .tableBox {
    margin-top: 25px;
  }
}

.innovationVoucher {
  font-weight: bold;
  display: flex;
  font-size: 20px;
  color: #333333;
  margin-bottom: 15px;

  span {
    margin-left: 10px;
  }

  :nth-child(3) {
    font-size: 16px;
    font-weight: bold;
    color: #ff0000;
    margin-left: 15px;
  }
}

.tabs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 34px;

  .left {
    display: flex;

    :nth-child(1) {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 29px;
      padding: 5px;
      opacity: 0.75;
      background: #3f7fff;
    }

    :nth-child(2) {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      margin-left: 17px;
    }
  }

  .right {
    display: flex;

    :nth-child(1) {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 70px;
      height: 30px;
      border-radius: 5px 5px 5px 5px;
      background: #adadad;
      margin-right: 10px;
      cursor: pointer;
    }

    :nth-child(2) {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 70px;
      height: 30px;
      border-radius: 5px 5px 5px 5px;
      background: #3f7fff;
      cursor: pointer;
    }
  }
}

.table-container {
  padding: 15px;
  border: 1px solid rgb(243, 247, 255) !important;
  background: rgb(252, 252, 252);
  margin-top: 15px !important;
  margin-bottom: 0px !important;
}

// 企业兑付申请表单样式
.applyform {
  padding: 10px;

  .box-cards {
    margin-bottom: 10px;

    .card-title {
      display: flex;
      align-items: center;

      div {
        width: 5px;
        height: 13px;
        background: rgb(88, 155, 248);
        margin-right: 10px;
      }

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }

    .el-checkbox-group {
      display: flex;
      flex-direction: column;
    }
  }
}

::v-deep .el-form {
  .el-form-item {
    display: flex;
  }

  .el-form-item__content {
    margin-left: 10px !important;
  }
}

::v-deep .columngroup {
  display: flex;
  flex-direction: column;

  .el-radio {
    margin-bottom: 10px;
  }
}

::v-deep .columngroup2 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .el-radio {
    margin-bottom: 10px;
  }
}

::v-deep .columngroup3 {
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  .el-radio {
    margin-bottom: 10px;
  }
}

.warnig_text {
  color: red;
  font-weight: bold;
  margin-left: 15px;
  font-size: 16px;
}

::v-deep.upload-attachments {
  .el-card__body {
    .el-row {
      height: 100px;
      border-bottom: 1px solid rgb(205, 211, 220);
      display: flex;
      align-items: center;

      .upload-title {
        font-weight: bold;
        font-size: 16px;
      }

      .upload-icon {
        cursor: pointer;
        font-size: 16px;
        color: rgb(86, 165, 253);

        i {
          margin-right: 5px;
        }
      }

      .upload-waring {
        color: red;
        font-size: 16px;
      }
    }
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.system-logo {
  position: relative;

  .logo-img {
    position: absolute;
    top: 10%;
    left: 50%;

    .el-form-item {
      align-items: center;
    }
  }
}
</style>
